module.exports = __webpack_public_path__ + "img/TPV-L1-5-Pagina6 C.b64e10d8.png";